import HomepageSlider from "@/components/homepage/HomepageSlider";
import BlogCard from "@/components/homepage/cards/BlogCard";
import {useCallback} from "react";
import Link from "next/link";
import styled from "styled-components";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";
import {useGetBlogDataQuery} from "@/redux/api";

const CategoryLink = styled.a`
    color: ${getColor('greenText')};
    font: "Josefin Sans";
    margin-right: 10px;
    text-decoration: none;
    :hover{
        color:${getColor('gold')}
    }
`

const CategoriesWrapper = styled.div`
    @media only screen and (${breakpoints.mobile}) {
        padding: 0 10px;
    }
`

export default function HomepageBlogsSection({sliderItems, sliderTitle, sliderSubtitle, sliderSidebarTitle}) {

    const {data} = useGetBlogDataQuery();

    const renderBlogCard = useCallback((item) => <BlogCard item={item} />, []);

    return (<div style={{padding: '50px 0'}}>
            <HomepageSlider
                items={data?.data?.blogs}
                title={sliderTitle}
                subtitle={sliderSubtitle}
                sidebarTitle={sliderSidebarTitle}
                renderItem={renderBlogCard}
            />

        <CategoriesWrapper>
            <div
                className={'container_slider'}
                style={{
                    marginTop:'50px',
                    display:'flex',
                    gap:'10px',
                    alignItems:'center',
                    flexWrap:'wrap',
                }}
            >


                    <div style={{
                        font: 'Josefin Sans',
                        fontWeight:'bold',
                        fontSize:'20px',
                        color: '#c49959',
                        textTransform: 'uppercase',
                        marginRight:'10px',
                    }}>
                        Popular Categories:
                    </div>
                    {
                        data?.data?.categories?.map((item,index) => {
                            return <CategoryLink
                                key={index}
                                href={item?.link ?? '#'}
                            >
                                {item?.title}
                            </CategoryLink>
                        })
                    }
            </div>
            </CategoriesWrapper>
    </div>)
}
